import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { projData } from "../../globals/data";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";
import { primaryInput } from "detect-it";
import "./styles.css"

const ArchiveOverlayTransition = ({triggerArchiveToHomepageTransition}) => {

    const [tileHeight, setTileHeight] = useState(null);
    const [tileWidth, setTileWidth] = useState(null);

    const archvTransVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                delay: 1.4,
                ease: [0.16, 1, 0.3, 1],
                duration: 0
            }
        }, exit: {
            opacity: 0, 
            transition: {
                duration: 0.125,
                delay: 0,
                ease: [0.7, 0, 0.84, 0]
            }
        }
    }

    const responsiveResize = () => {
        let curHeight = window.innerHeight;

        if(primaryInput == 'mouse'){
            // Homepage Transition Is 20dvh
            setTileHeight((curHeight/5) - 20)
            setTileWidth((curHeight/5) * 2.25)
        } else{
            setTileHeight((curHeight/4) - 19)
            setTileWidth(((curHeight/4) - 20) * (4/3) * 1.25)
        }

    }

    useEffect(() => {
        responsiveResize();
        window.addEventListener('resize', responsiveResize, false);
    }, [])

    return(
        <div className="">
            <AnimatePresence mode="wait">
                { triggerArchiveToHomepageTransition && tileHeight && tileWidth &&
                    <motion.div 
                        className="archv_to_home__wrapper" 
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        variants={archvTransVariants}    
                    >
                        <div className="p_t_transition__wrapper" 
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate3d(-50%, -50%, 0)",
                                height: tileHeight+"px",
                                width: tileWidth+"px",
                                overflow: "hidden"
                            }}
                        >
                            <ProgressiveBackgroundImg
                                placeholderSrc={projData[0].thumbnails.placeholder}
                                src={projData[0].thumbnails.desktop}
                                idx={0}
                                forceFullWidth={true}
                                animateIn={false}
                                startFullRes={true}

                            />  
                        </div>
                    </motion.div>
                }
            </AnimatePresence>
        </div>
    )
}

export default ArchiveOverlayTransition;